let OnboardingProvider = /*#__PURE__*/function (OnboardingProvider) {
  OnboardingProvider["AMAZON"] = "amazon";
  OnboardingProvider["EBAY"] = "ebay";
  OnboardingProvider["ETSY"] = "etsy";
  OnboardingProvider["PAYPAL"] = "paypal";
  OnboardingProvider["SHIPENGINE_OAUTH_DUMMY"] = "shipengine_oauth_dummy";
  OnboardingProvider["SHIPENGINE_TIKTOK"] = "shipengine_tiktok";
  return OnboardingProvider;
}({});

export { OnboardingProvider };
//# sourceMappingURL=OnboardingProvider.js.map
